import { styled } from '@mui/material/styles';
import React, { FC, ReactNode } from 'react';

import { AnalyticsService, AnalyticsTrackingEvent } from '../../analytics';

export interface MessageCardProps {
  cta: ReactNode;
  onActionClick?: (event: React.MouseEvent<HTMLElement>) => void;
  linkTo?: string;
  title: string;
  content: ReactNode;
  className?: string;
  trackedEventName?: AnalyticsTrackingEvent;
  trackingParams?: Record<string, any>;
}

const MessageCardWrapper = styled('div')(() => ({
  boxSizing: 'border-box',
  textAlign: 'center',
  border: `1px solid #dcdddc`,
  borderRadius: 10,
  padding: '27px 40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#f6f8fa',
  gap: 10,
}));

const MessageCardTitle = styled('div')(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  color: theme.vars.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
  },
}));

const MessageCardContent = styled('div')(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  color: theme.vars.palette.text.primary,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: 14,
  },
}));

const MessageActionButton = styled('button')(({ theme }) => ({
  marginTop: 10,
  height: 50,
  fontSize: 16,
  whiteSpace: 'nowrap',
  padding: '0 20px',
  fontWeight: 600,
  borderRadius: '999px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  minWidth: 355,
  border: 'none',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    minWidth: 'unset',
    height: 44,
    fontSize: 14,
  },
}));

const MessageCard: FC<MessageCardProps> = ({
  title,
  content,
  cta,
  onActionClick,
  linkTo,
  trackedEventName,
  trackingParams,
  ...props
}) => {
  return (
    <MessageCardWrapper {...props}>
      <MessageCardTitle className="store-message-card__title">{title}</MessageCardTitle>
      <MessageCardContent className="store-message-card__content">{content}</MessageCardContent>
      <MessageActionButton
        className="store-message-card__cta"
        onClick={(e) => {
          AnalyticsService?.track(trackedEventName || AnalyticsTrackingEvent.BUTTON_CLICK, {
            buttonName: cta,
            linkTo,
            ...trackingParams,
          });
          onActionClick?.(e);
        }}
      >
        {cta}
      </MessageActionButton>
    </MessageCardWrapper>
  );
};

export default MessageCard;
